<template>
	<div class="searchAuto pt-2" @mouseleave="closeSearchHind">
    <!-- <input type="text" placeholder="Enter Country name..." v-model="query" @keyup="getData()" autocomplete="off" class="form-control input-lg" /> -->
	
	 
	  
	  <form @submit.prevent="changeQuery">
           
				  
	  <b-input-group style="min-width:290px;border:0px;box-shadow: -3px 2px 11px 2px #723f8b;" >
	  
		<!--<b-navbar-toggle target="menuWeb" v-b-toggle.menuWeb></b-navbar-toggle> -->
		<b-input-group-append class="d-none d-md-block">
			
		 <b-button type="button" variant="warning" class="searchBtnHColor" style="border-radius: 4px 0px 0px 5px" v-b-toggle.menuWeb @click="clickHandler()"><b-icon icon="list" aria-hidden="true"></b-icon> </b-button>
		 </b-input-group-append>
		<b-form-input placeholder="Search for products, brands etc."  :class="{ loading : loading === true }" v-model="query" style="border:0px;" @keyup="getData()" autocomplete="off" ></b-form-input>
		<b-input-group-append>
		  <!--<b-button variant="outline-success">Button</b-button> -->
		  <b-button type="submit" variant="warning" class="searchBtnHColor"><i class="fa fa-search" aria-hidden="true"></i></b-button>
		</b-input-group-append>
	  </b-input-group>
	  
	</form>
	  
	 
	  
	  <div class="panel-footer" v-if="search_data.length>0 || brandSeg_data.length>0" > <!-- @mouseleave="closeSearchHind" -->
        <ul class="list-group scrollBrand">
		 <a :href="'/brand/'+datab.urlslug" class="list-group-item" v-for="datab in brandSeg_data"  :key="datab.id">{{ datab.brand_name }}</a>
          <a :href="'/search/?q='+data1.title" class="list-group-item" v-for="data1 in search_data" @click="getName(data1.title)" :key="data1.id">{{ data1.title }}</a>
        </ul>
      </div>
	  
    </div>
  
</template>

<script>
export default {
  name: "autocompleteSearch",
  props: {
   /* category:Boolean,
    details:Boolean,
    relative:Boolean,
    product:Object,
	myroleId:{type:String}, */
	
  },
  data(){
    return {
	  deleteUrl: this.$root.WEBAPI+'webapi/searchAutoload',
      product_qty:1,
      special_price:100,
      price:200,
	  query:'',
      search_data:[],
      brandSeg_data:[],
	  loading:false,
	  
    }
  },
  methods:{
	 getData(){
	 
        this.search_data = [];
		console.log(this.query.length);
		if(this.query.length==0){
		this.search_data = [];
		this.brandSeg_data = [];
		}else{
		
			this.axios.post(this.deleteUrl, {
			  queryPost:this.query
			}).then(response => {
			  //this.search_data =response.data.result;
			  this.search_data =response.data.result.product;
			  this.brandSeg_data =response.data.result.brandSeg;
			});
		}
      },
      getName(name){
        this.query = name;
        this.search_data = [];
      },
	  closeSearchHind(){
		
		this.search_data = [];
	  },
	  changeQuery() {
		window.location = '/search/?q=' + this.query;
		//this.name = submitEvent.target.elements.name.value
		},
		clickHandler() {
			console.log(this.$refs.collepsmypanel);
			
			//this.$refs.collepsmypanel.click();
		}	
	  
  }
};
</script>
<style scoped lang="scss">
	.searchAuto{
		.list {
			
			&-group{
				max-height: 240px;
				
				display: flex;
				flex-direction: column;
				padding-left: 0;
				margin-bottom: 0;
				border-radius: .25rem;
				position: absolute;
				z-index: +99999; 
				width: 27%;
				font-size: 12px;
				&-item{
					padding: 6px;
				}
			}
		}
			.collapsed{ 
				/*max-width: 50px;*/
				max-width: 215px !important;
				padding:0.375rem 0.75rem !important;
				.collapsedDefult{max-width:215px; }
			}
			
			
			
	}
	
</style>